import { ref, onMounted } from "vue";
import { useCompanyStore } from "@/stores";
import { useRoute } from "vue-router";

export default function useCompany() {
  const company = ref({});
  const route = useRoute();
  const companyStore = useCompanyStore();

  const getCompany = async () => {
    const data = await companyStore.getCompany({
      id: route.params.id,
    });
    company.value = data;
  };

  onMounted(getCompany);

  return {
    company,
    getCompany,
  };
}
